
    const version = '5.150.2-1004436-stg';
    export default version;
